export const MAGIC_NUMBERS_MAPPING = {
    "jpeg": ["FFD8FFE0", "FFD8FFE1", "FFD8FFE8", "FFD8FFE2", "FFD8FFEE", "ffd8ffe3"],
    "jpg": ["FFD8FFE0", "FFD8FFE1", "FFD8FFE8", "FFD8FFE2", "FFD8FFEE", "ffd8ffe3"],
    "png": ["89504E47"],
    "pdf": ["255044462D312E"],
    "xlsx": ["504B0304"],
    "xls": ["D0CF11E0A1B11AE1"],
    "doc": ["D0CF11E0A1B11AE1"],
    "docx": ["504B0304"],  
    "mp4": ["00000018", "00000020"],
    "bmp": ["424D"],
    "ogg": ["4F676753"],
    "webm": ["1A45DFA3"],
    "avi": ["52494646"],
    "webp": ["52494646"],
    "mov": ["00000014"],
    "wav": ["52494646"],
    "tiff": ["4D4D002A", "49492A00"],
}

export const MIME_TYPE_MAPPING = {
    'jpeg': ['image/jpeg'],
    'jpg': ['image/jpeg'],
    'png': ['image/png'],
    'pdf': ['application/pdf'],
    'xlsx': ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    'xls': ['application/vnd.ms-excel'],
    'doc': ['application/msword'],
    'docx': ['application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    'mp4': ['video/mp4'],
    'csv': ['text/csv'],
    'bmp': ['image/bmp'],
    'ogg': ['audio/ogg', 'video/ogg', 'audio/opus'],
    'webm': ['video/webm'],
    'avi': ['video/x-msvideo'],
    'webp': ['image/webp'],
    'mov': ['video/quicktime'],
    'wav': ['audio/wav'],
    'tiff': ['image/tiff'],
    'wmv': ['video/x-ms-wmv'],
}
